<!-- 组件名：download.vue | 路由路径：/download/ -->
<template>
  <div class="page-wrap">
    <FmNavBar />

    <div class="container">
      <div class="header">
        <h1>Download FMWhatsApp APK Latest Version</h1>
        <p>Safe | Anti-Ban | Updated 2026 | No Malware</p>
        <a href="javascript:void(0)" class="btn" @click.prevent="downloadNow">DOWNLOAD NOW</a>
      </div>

      <div class="section">
        <h2>App Information</h2>
        <table>
          <tr><td>App Name</td><td>FMWhatsApp APK</td></tr>
          <tr><td>Version</td><td>v10.10</td></tr>
          <tr><td>Size</td><td>82 MB</td></tr>
          <tr><td>Android</td><td>5.0+</td></tr>
          <tr><td>Updated</td><td>2026</td></tr>
          <tr><td>Developer</td><td>FMWhats MOD Team</td></tr>
        </table>
      </div>

      <div class="section">
        <h2>How to Download Safely</h2>
        <ol>
          <li>Click the Download button above</li>
          <li>Wait 5 seconds for auto-start</li>
          <li>Save the APK to your Downloads folder</li>
          <li>Verify file size is 82 MB</li>
        </ol>
      </div>

      <div class="section">
        <h2>Installation Guide</h2>
        <ol>
          <li>Enable Unknown Sources in Settings → Security</li>
          <li>Open the downloaded APK file</li>
          <li>Tap Install</li>
          <li>Verify your phone number</li>
          <li>Restore chat backup</li>
        </ol>
      </div>

      <div class="section">
        <h2>Update Instructions</h2>
        <ul>
          <li>Download latest APK from this page</li>
          <li>Install without uninstalling the app</li>
          <li>Restart FMWhatsApp</li>
        </ul>
      </div>

      <div class="section">
        <h2>Safety Disclaimer</h2>
        <p>FMWhatsApp is a third-party modified version of WhatsApp. We provide clean, tested APK files but are not affiliated with official WhatsApp. Use at your own risk.</p>
      </div>

      <div class="mini-footer">© 2026 FMWhatsApp Official</div>
    </div>
  </div>
</template>

<script>
import FmNavBar from '@/components/FmNavBar.vue'

export default {
  name: 'Download',
  components: { FmNavBar },
  methods: {
    // 中文注释：下载按钮可按项目需要替换成真实下载外链
    downloadNow() {
      this.$router.push('/download/').catch(() => {})
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}
.page-wrap {
  background: #f5f5f5;
  color: #222;
  min-height: 100vh;
}
.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
}
.header {
  background: #075e54;
  color: #fff;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  margin: 20px 0;
}
.header h1 {
  font-size: 34px;
  margin-bottom: 10px;
}
.header p {
  font-size: 18px;
}
.btn {
  background: #25d366;
  color: #fff;
  padding: 14px 28px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 700;
  display: inline-block;
  margin-top: 15px;
}
.btn:hover {
  background: #1ea854;
}
.section {
  background: #fff;
  padding: 28px;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
h2 {
  color: #075e54;
  margin-bottom: 15px;
  border-left: 4px solid #25d366;
  padding-left: 10px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}
td,
th {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}
th {
  background: #075e54;
  color: #fff;
}
ol,
ul {
  padding-left: 25px;
  margin: 15px 0;
}
.mini-footer {
  text-align: center;
  padding: 30px;
  color: #666;
}

@media (max-width: 768px) {
  .header h1 {
    font-size: 26px;
  }
  .section {
    padding: 18px;
  }
}
</style>
